<ng-container *transloco="let t; prefix: 'OrganizationSettings'">  
  <div>
      <span class="msi-h2 msi-bold">{{ t('title') }}</span>
      <form [formGroup]="OrganizationSettingsForm" (ngSubmit)="onSubmit()" class="form-spacing">        
        <span class="msi-h4 msi-bold msi-padding-top-m">{{ t('label.defaultUnits') }}</span>
        <div class="input-container select-container">
          <p-select class="full-width-input"
                    placeholder="Meters"
                    formControlName="defaultUnits"
                    [options]="Units"
                    [disabled]="IsSubmitting || !OrganizationSettingsForm.valid"
                    (onChange)="onSubmit()">
            <ng-template pTemplate="selectedItem" let-value>{{ UnitsText[value] | titlecase }}</ng-template>
            <ng-template pTemplate="item" let-opt>{{ UnitsText[opt] | titlecase }}</ng-template>
          </p-select>
          @if (IsSubmitting) {
            <p-progress-spinner class="justify-content-center msi-margin-left-s" />
          }
        </div>       
      </form>
    </div>      
</ng-container>
